import api from "../helpers/api";
import { ToastChakra } from "../helpers/toast";

const baseURL = process.env.REACT_APP_API_URL;


const getAllPresupuestos = async (data) => {
    const { page, perPage } = data;
    const response = await api.get(`${baseURL}/presupuesto/listar?pagina=${page}&cantidadPagina=${perPage}`);
    // console.log('esto trae presupuestos :', response.data);
    return response.data;  // Aquí obtienes el objeto con `data` y `pagination`
}
const createPresupuesto = async (data) => {
    const response = await api.post(`${baseURL}/presupuesto/crear`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('PRESUPUESTO CREADO', 'El presupuesto se ha creado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}
const updatePresupuesto = async (data) => {
    // console.log("Datos enviados al backend desde el servicio:", data); // Depuración
    const response = await api.put(`${baseURL}/presupuesto/modificar/${data.id}`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('PRESUPUESTO MODIFICADO', 'El presupuesto se ha modificado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
};
const deletePresupuesto = async (id) => {
    const response = await api.delete(`${baseURL}/presupuesto/eliminar/${id}`);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('PRESUPUESTO ELIMINADO', 'El presupuesto se ha eliminado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

const getPresupuestoById = async (id) => {
    const response = await api.get(`${baseURL}/presupuesto/listar/${id}`);
    if (response.status === 200 || response.status === 201) {
        // console.log('esto trae presupuestos by Id :', response.data);
        return response.data;
    }
}

const getSiguienteNroPresupuesto = async () => {
    const response = await api.get(`${baseURL}/presupuesto/siguiente_nro_presupuesto`);
     if (response.status === 200 || response.status === 201) {
      //  console.log('esto trae nroSiguiente :', response.data);
        return response.data;
     }
}

const presupuestosService = {
    getAllPresupuestos,
    createPresupuesto,
    updatePresupuesto,
    deletePresupuesto,
    getPresupuestoById,
    getSiguienteNroPresupuesto
}

export default presupuestosService;